import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit_filled",
  "use": "icon-edit_filled-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 200 200\" id=\"icon-edit_filled\"><path fill=\"#437dff\" d=\"m102.719 48.925 44.194 44.194L66.6 173.43a12.5 12.5 0 0 1-8.831 3.663H25a6.25 6.25 0 0 1-6.25-6.25v-32.769c0-3.315 1.318-6.494 3.663-8.838zm44.194-26.512 26.518 26.512a12.49 12.49 0 0 1 2.711 13.625 12.5 12.5 0 0 1-2.711 4.056L155.75 84.281l-44.188-44.187 17.675-17.688a12.5 12.5 0 0 1 17.676 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol